/**
 * @file app/tauri/sentryTauri.js
 * Sentry for the Tauri webview (renderer). The Rust side initializes its own
 * native `sentry` guard in `src-tauri/src/lib.rs`; this covers the JS layer.
 *
 * NOTE: on Android/iOS the app already initializes `@sentry/react-native` in
 * `index.js`. This module is ONLY for the Tauri desktop webview, where the
 * React-Native SDK's native pieces are absent — there we use the plain browser
 * SDK. Guarded so it is a no-op unless running under Tauri.
 */

export const SENTRY_DSN =
  "https://584fa43f5472b5bea80fb6b339f7197d@o4511590534348800.ingest.de.sentry.io/4511590550470736";

let started = false;

/** Initialize Sentry once for the Tauri renderer. Safe to call anywhere. */
export async function initTauriSentry() {
  if (started) return;
  if (typeof window === "undefined" || !(window.__TAURI_INTERNALS__ || window.__TAURI__)) return;
  started = true;
  try {
    const Sentry = await import("@sentry/browser");
    Sentry.init({
      dsn: SENTRY_DSN,
      release: `happy-app@${(typeof window !== "undefined" && window.appVersion) || "0.0.0"}`,
      environment: process.env.NODE_ENV === "development" ? "development" : "production",
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("[sentry] tauri renderer init failed", e);
  }
}

export default initTauriSentry;
